// 除以100保留两位小数点
export const divide=(str,type)=> {
    let floatVal = parseFloat(str);
    if (isNaN(floatVal )) {
      return 0;
    }
    floatVal = Math.round(str * 100) / 10000;
    let strVal = floatVal .toString();
    let searchVal = strVal.indexOf('.');
    if (searchVal < 0) {
      searchVal = strVal.length;
      strVal += '.';
    }
    while (strVal.length <= searchVal + 2) {
      strVal += '0';
    }
    
    // return strVal
    if(type == 'float'){
      return parseFloat(strVal);
    }else {
      return strVal
    }
  }
  // 乘以100保留两位小数点
  export const multiply=(str) =>{
    let floatVal = parseFloat(str);
    if (isNaN(floatVal)) {
      return 0;
    }
    floatVal = Math.round(str * 65400) / 100000;
    let strVal = floatVal.toString();
    let searchVal = strVal.indexOf('.');
    if (searchVal < 0) {
      searchVal = strVal.length;
      strVal += '.';
    }
    while (strVal.length <= searchVal + 2) {
      strVal += '0';
    }
    return strVal
    // return parseFloat(strVal);
  }


// WEBPACK FOOTER //
// ./src/utils/tool.js